import React from "react";
import {
Button,
  IconButton,
  Input,
  Select,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
export function SearchBar(props) {
  // Pass the computed styles into the `__css` prop
  const { variant, children, ...rest } = props;
  // Chakra Color Mode
  const mainorange = useColorModeValue("yellow.700", "yellow.700");
  const searchIconColor = useColorModeValue("gray.700", "gray.200");
  const inputBg = useColorModeValue("white", "gray.800");
  return (
    <InputGroup
      bg={inputBg}
      borderRadius="15px"
      w="100%"
      _focus={{
        borderColor: { mainorange },
      }}
      _active={{
        borderColor: { mainorange },
      }}
    >
      <InputLeftElement
        children={
          <IconButton
            bg="inherit"
            borderRadius="inherit"
            _hover="none"
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
          ></IconButton>
        }
      />
      <Input
        /* add onchange event handler */
        onChange={props.onChange}
        fontSize="l"
        py="24px"
        placeholder="Filter/ Search for a document..."
        borderRadius="inherit"
      />
      <Select
      rootProps={{  style:{ paddingLeft: 18, paddingTop: 5,  paddingBottom: 5 } }}
        fontSize="l"
        py="26px"
        onChange={props.onChangeCountry}
         placeholder='Filter by Country'>
         {props.countries.map((country) => (
            <option value={country}>{country}</option>
            ))}
      </Select>
      <Select
      rootProps={{  style:{ paddingLeft: 18, paddingTop: 5,  paddingBottom: 5 } }}
        fontSize="l"
        py="26px"
        onChange={props.onChangeYear}
         placeholder='Filter by Year'>
         {props.uniqueYears.map((year) => (
            <option value={year}>{year}</option>
            ))}
      </Select>
       { props.filter && <Button
      style={{ width: 420, paddingLeft: 18, paddingTop: 6,  paddingBottom: 6 } }
      onClick={ () => {
       props.onChangeRest();
       }} colorScheme='red'>Reset Filter</Button> }
    </InputGroup>
  );
}
